import { NgModule } from "@angular/core";
import { ODataFilterFactoryService } from "./services";
import { RouterModule } from "@angular/router";

@NgModule({
    imports: [RouterModule],
    providers: [ODataFilterFactoryService],
})
export class OdataModule { }
